import React, { Fragment, useState, useEffect } from 'react';
import { Card, Col, Row, Tab, Nav, Breadcrumb, Spinner, Alert } from 'react-bootstrap';
import { SentimentColumnChart, EmotionColumnChart } from './columndata';
import { FrequentQuestionsChart } from './frequentquestionsdata';
import { ConversationAnalysisChart } from './conversationdata';
import { ConversationAnalysisPie } from './conversationanalysis';
import { TalkingSilencePieChart } from './talkingsilencepiedata';
import { TemasFrecuentesChart } from './temasfrecuentes';
import { DurationTimeChart } from './durationtimechart';
import { FCRChart } from './fcr-chart';
import { PalabrasFrecuentesChart } from './palabrasfrecuentes';

const SpeechAnalytics = () => {


    // Esto solo es temporal - Estado de carga y datos insuficientes _____________________________________
    const [isLoading, setIsLoading] = useState(true);
    const [showInsufficientData, setShowInsufficientData] = useState(false);

    useEffect(() => {
        const fetchSpeechAnalytics = async () => {
            try {
                setIsLoading(true);
                console.log('🔍 Iniciando carga de Speech Analytics...');
                
                const response = await fetch('/api/dashboard/speech-analytics', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                console.log('✅ Respuesta del backend:', result);
                // Verificar si hay datos en el array
                if (result.data && Array.isArray(result.data) && result.data.length > 0) {
                    // Hay datos, procesarlos aquí en el futuro
                    setIsLoading(false);
                    setShowInsufficientData(false);
                } else {
                    // Array vacío o sin datos
                    setIsLoading(false);
                    setShowInsufficientData(true);
                }
                
            } catch (error) {
                console.log('❌ Error en API:', error.message);
                setIsLoading(false);
                setShowInsufficientData(true);
            }
        };

        fetchSpeechAnalytics();
    }, []);

    // Esto solo es temporal - Componentes de UI
    const LoadingComponent = () => (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '300px' }}>
            <div 
                className="spinner-border" 
                role="status"
                style={{
                    width: '3rem',
                    height: '3rem',
                    border: '0.25em solid #e3e3e3',
                    borderTop: '0.25em solid #5294e2',
                    borderRadius: '50%',
                    animation: 'spinner-border 0.75s linear infinite'
                }}
            >
                <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3" style={{ color: '#5294e2' }}>Cargando datos de Speech Analytics...</p>
        </div>
    );

    const InsufficientDataComponent = () => (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '300px' }}>
            <Alert 
                variant="light" 
                className="text-center border-0" 
                style={{ 
                    backgroundColor: '#f8f9ff', 
                    border: '1px solid #5294e2',
                    color: '#5294e2'
                }}
            >
                <Alert.Heading style={{ color: '#5294e2' }}>Datos Insuficientes</Alert.Heading>
                <p style={{ color: '#5294e2', margin: 0 }}>
                    No hay suficientes datos disponibles para mostrar los análisis de Speech Analytics.
                    <br />
                    Por favor, inténtalo más tarde o contacta al administrador.
                </p>
            </Alert>
        </div>
    );

    // _____________________________________________________________________________________________________

    return (
        <Fragment>
            <Row>
                <Col xl={12}>
                    <div className="breadcrumb-header" style={{marginBottom: 24}}>
                        <Breadcrumb>
                            <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
                            <Breadcrumb.Item active>Speech Analytics</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Card className="custom-card">
                        <Card.Header>
                            <Card.Title>
                                Speech Analytics
                            </Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Tab.Container defaultActiveKey="first">
                                <style>
                                    {`
                                    .speech-tab-style .nav-link {
                                        color: #495057;
                                        position: relative;
                                        transition: color 0.3s ease;
                                    }
                                    .speech-tab-style .nav-link.active {
                                        color: #6A8BFF !important;
                                        background-color: transparent !important;
                                    }
                                    .speech-tab-style .nav-link::after {
                                        content: "";
                                        position: absolute;
                                        height: 3px;
                                        width: 100%;
                                        background-color: #6A8BFF;
                                        bottom: 0;
                                        left: 0;
                                        transform: scaleX(0);
                                        transform-origin: bottom left;
                                        transition: transform 0.3s ease;
                                    }
                                    .speech-tab-style .nav-link.active::after {
                                        transform: scaleX(1);
                                    }
                                    `}
                                </style>
                                <Nav variant="pills" className="nav nav-tabs speech-tab-style nav-justified mb-3 d-sm-flex d-block" id="speechTab" role="tablist">
                                    <Nav.Item>
                                        <Nav.Link
                                            eventKey="first"
                                            id="dashboard-tab"
                                            type="button"
                                            className="border-0 bg-transparent"
                                        >
                                            <i></i> Conversación
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            eventKey="second"
                                            id="sentiment-tab"
                                            type="button"
                                            className="border-0 bg-transparent"
                                        >
                                            Sentimiento
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            eventKey="third"
                                            id="words-tab"
                                            type="button"
                                            className="border-0 bg-transparent"
                                        >
                                            Preguntas frecuentes
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Content className="tab-content" id="speechTabContent">
                                    <Tab.Pane className="tab-pane fade show" id="dashboard-tab-pane" role="tabpanel" eventKey="first"
                                        aria-labelledby="dashboard-tab" tabIndex={0} style={{ border: '0px' }}>
                                        {/* <Row className="row-sm h-100">
                                            <Col xl={12} className="mb-3">
                                                <Card className="custom-card h-100" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Header>
                                                        <Card.Title>Análisis de conversación entre el agente y cliente</Card.Title>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div id="conversation-analysis-chart" className="h-100">
                                                            <ConversationAnalysisChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xl={6} className="mb-3">
                                                <Card className="custom-card h-100" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Header>
                                                        <Card.Title>Promedio de conversaciones por minuto</Card.Title>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div id="duration-time-chart" className="h-100">
                                                            <DurationTimeChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xl={6} className="mb-3">
                                                <Card className="custom-card h-100" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Header>
                                                        <Card.Title>Promedio de tiempo de silencio</Card.Title>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div id="talking-silence-pie-chart" className="h-100">
                                                            <TalkingSilencePieChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xl={6}>
                                                <Card className="custom-card h-100" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Header>
                                                        <Card.Title>Análisis de Métricas de Conversación</Card.Title>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div id="conversation-analysis-pie-chart" className="h-100">
                                                            <ConversationAnalysisPie />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xl={6}>
                                                <Card className="custom-card h-100" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Header>
                                                        <Card.Title>FCR (First Call Resolution)</Card.Title>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div id="fcr-chart" className="h-100">
                                                            <FCRChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row> */}
                                        
                                        {/* temporal */}
                                        {isLoading ? (
                                            <LoadingComponent />
                                        ) : showInsufficientData ? (
                                            <InsufficientDataComponent />
                                        ) : null}
                                    </Tab.Pane>
                                    <Tab.Pane className="tab-pane fade" id="sentiment-tab-pane" eventKey="second"
                                        role="tabpanel" aria-labelledby="sentiment-tab" tabIndex={0} style={{ border: '0px' }}>
                                        {/* <Row >
                                            <Col xl={6}>
                                                <Card className="custom-card" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Body>
                                                        <div id="sentiment-column-chart">
                                                            <SentimentColumnChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xl={6}>
                                                <Card className="custom-card" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Body>
                                                        <div id="emotion-column-chart">
                                                            <EmotionColumnChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row> */}
                                        
                                        {/* temporal */}
                                        {isLoading ? (
                                            <LoadingComponent />
                                        ) : showInsufficientData ? (
                                            <InsufficientDataComponent />
                                        ) : null}
                                    </Tab.Pane>
                                    <Tab.Pane className="tab-pane fade" id="words-tab-pane" role="tabpanel" eventKey="third"
                                        aria-labelledby="words-tab" tabIndex={0} style={{ border: '0px' }}>
                                        {/* <Row className="row-sm h-100">
                                            <Col xl={6} className="mb-3">
                                                <Card className="custom-card h-100" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Header>
                                                        <Card.Title>Preguntas frecuentes</Card.Title>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div id="frequent-questions-chart" className="h-100">
                                                            <FrequentQuestionsChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xl={6} className="mb-3">
                                                <Card className="custom-card h-100" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Header>
                                                        <Card.Title>Temas frecuentes</Card.Title>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div id="temas-frecuentes-chart" className="h-100">
                                                            <TemasFrecuentesChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        
                                            <Col xl={6} className="mb-3">
                                                <Card className="custom-card h-100" style={{ border: '1px solid #BDCBFF' }}>
                                                    <Card.Header>
                                                        <Card.Title>Palabras frecuentes</Card.Title>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <div id="palabras-frecuentes-chart" className="h-100">
                                                            <PalabrasFrecuentesChart />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            
                                        </Row> */}
                                        
                                        {/* Esto solo es temporal - Código de carga temporal para el tab de Preguntas Frecuentes */}
                                        {isLoading ? (
                                            <LoadingComponent />
                                        ) : showInsufficientData ? (
                                            <InsufficientDataComponent />
                                        ) : null}
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};

export default SpeechAnalytics;